import { createSlice } from '@reduxjs/toolkit'
import { Observation } from '../../../../model/observation'
import { initialStoreState } from '../../../initialState'

const observationsSlice = createSlice({
  name: 'observations',
  initialState: initialStoreState.observations,
  reducers: {
    observationsSet: (state, action) => {
      return [...state, ...action.payload]
    },
    observationsCleared: (state) => {
      state.splice(0, state.length)
    },
    observationsBulkSetEducationReportId: (state, action) => {
      action.payload.observationIds.forEach((id) => {
        state.map((el: Observation) =>
          el.observation_id === id
            ? {
                ...el,
                id_education_report: action.payload.educationReportId,
              }
            : el
        )
      })
    },
    observationAdded: (state, action) => {
      state.push(action.payload)
    },
    observationUpdated: (state, action) => {
      return state.map((observation: Observation) => {
        if (observation.observation_id !== action.payload.observation_id) {
          // This isn't the item we care about - keep it as-is
          return observation
        }
        return {
          ...observation,
          ...action.payload,
          observation_file: action.payload.observation_file,
        }
      })
    },
    observationRemoved: (state, action) => {
      return state.filter(
        (observation) => observation?.observation_id !== action.payload
      )
    },
  },
})

export const {
  observationsSet,
  observationsCleared,
  observationsBulkSetEducationReportId,
  observationAdded,
  observationUpdated,
  observationRemoved,
} = observationsSlice.actions

export default observationsSlice.reducer